export default "__VITE_ASSET__CsVD4duB__";